import { inlineGlossClassName } from '@w/content-blocks/src/language-span'
import { relativeColorClasses, relativeColorName } from '@w/ui/lib/relative-color'
import type { BlockView } from '../view-api'

export const LanguageView: BlockView = ({ block, children }) => {
  if (block.type !== 'l') return null
  const props = { 'data-block-id': block.id, 'data-inline-presentation-type': 'l', 'data-inline-text-payload': JSON.stringify({ block }) }
  if (!block.$gloss) return <span {...props} lang={block.lang}>{children}</span>
  // The gloss is non-editable decoration outside the span's child slot.
  return <span {...props}>
    <span lang={block.lang}>{children}</span><span contentEditable={false} className={inlineGlossClassName}>{` (${block.$gloss})`}</span>
  </span>
}

export const EmphasisView: BlockView = ({ block, children }) => block.type === 'em'
  ? <span data-block-id={block.id} data-inline-presentation-type="em" data-inline-text-payload={JSON.stringify({ block })}
    data-color={block.color} className={relativeColorClasses[relativeColorName(block.color)].split(' ').filter(token => !token.includes('text-')).join(' ')}>{children}</span> : null
